<template>
    <div class="person-list-container">
        <div class="pointer no-border no-background-color" @click="toggleList">
            <ul class="m-0">
                <li v-if="nbElements > 1">
                    <div class="avatar" :class="avatarSize">
                        <span>
                            {{ nbElements }}
                        </span>
                    </div>
                    <div class="dinlineb ml-1">
                        {{
                            placeholder != ''
                                ? placeholder
                                : $l10n.n__('Personne', 'Personnes', nbElements)
                        }}
                    </div>
                </li>

                <li v-for="elem in list" v-if="nbElements == 1" :key="elem.id">
                    <avatar-inline
                        :enableAvatar="enableAvatar"
                        :data="elem"
                        :size="size"
                        :context="context"
                        :relatedData="relatedData"
                    />
                </li>
            </ul>
        </div>

        <div
            v-if="displayList"
            class="person-list pabsolute zi-1000 top-left well p-0 span_12 shadow b-0 ellipsis wp-10"
            @click="toggleList"
            @mouseleave="toggleList"
        >
            <ul class="m-0">
                <li class="p-2">
                    <div class="avatar" :class="avatarSize">
                        <span>
                            {{ nbElements }}
                        </span>
                    </div>
                    <div class="dinlineb ml-1">
                        {{
                            placeholder != ''
                                ? placeholder
                                : $l10n.n__('Personne', 'Personnes', nbElements)
                        }}
                    </div>
                </li>
            </ul>
            <ul class="person m-0 bt-1 pt-1 mxh-200 ovy-auto">
                <li v-for="elem in list" :key="elem.id" class="p-2 cpointer">
                    <avatar-inline
                        :data="elem"
                        :size="size"
                        :context="context"
                        :relatedData="relatedData"
                        :enableAvatar="enableAvatar"
                    />
                </li>
            </ul>
        </div>
    </div>
</template>
<script>
import AvatarMixins from '../../mixins/AvatarMixins';
import AvatarInline from 'vcomponents/utilities/AvatarInline.vue';

export default {
    components: {
        AvatarInline,
    },
    mixins: [AvatarMixins],
    props: {
        list: {
            type: Array,
            required: true,
        },
        placeholder: {
            type: String,
            default: '',
            required: false,
        },
        size: {
            type: String,
            required: false,
            default: 'small',
        },
        context: {
            type: String,
            required: false,
            default: '',
        },
        relatedData: {
            type: [Object, Boolean],
            required: false,
            default: false,
        },
        enableAvatar: {
            type: Boolean,
            required: false,
            default: true,
        },
    },

    data() {
        return {
            displayList: false,
        };
    },
    computed: {
        nbElements() {
            return Array.isArray(this.list) ? this.list.length : Object.keys(this.list).length;
        },
    },
    methods: {
        toggleList() {
            if (this.nbElements > 1) {
                this.displayList = !this.displayList;
            }
        },
        getName(person) {
            return person.fullName ? person.fullName : person.name;
        },
        hasPicture(elem) {
            return (
                elem.avatar.type == 'twitteruserpic' ||
                elem.avatar.type == 'externaluserpic' ||
                elem.avatar.type == 'picture'
            );
        },
    },
};
</script>

<style lang="scss" scoped>
@use '~@sellsy/styleguide/src/_variables' as *;

.person-list ul.person li:hover {
    background-color: $primary-05;
    .person-name {
        color: $primary-50;
    }
}

.person {
    overflow-x: hidden;
    .fullname {
        width: calc(100% - 40px);
        padding-left: 8px;
    }
}
.person-name {
    width: calc(100% - 45px);
}

.cd-timeline-block {
    .person-list {
        width: auto !important;
    }
}
</style>
